import { Card, Col, Row } from 'react-bootstrap';
import CollegeOverview from './CollegeOverview';
import ReverificationOverview from './ReverificationOverview';
import ReverificationsDetails from './ReverificationsDetails';
import React, { useEffect, useRef } from 'react';
import { ClientService } from '../../component/services/client.service';
import { ChartDataItem } from '../../component/Charts/DonutChart';
import StatsCard from '../../component/Cards/StatsCard';
import { faClipboardCheck, faCheckCircle, faUserCheck, faUserGraduate, faTimesCircle, faUsers, faUniversity, faPlay } from '@fortawesome/free-solid-svg-icons'
import StatsCardWithProgress from '../../component/Cards/StatsCardWithProgress';
import CollegeStatsModal from '../../component/modals/CollegeStats.modal';
import { CSVLink } from "react-csv";
import { set } from 'react-datepicker/dist/date_utils';

export default function ReverificationDashboard() {

    const [loading, setLoading] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);
    const [chartData, setChartData] = React.useState<ChartDataItem[]>([]);
    const [collegeStatsDataStarted, setCollegeStatsStartedData] = React.useState<any>();
    const [collegeStatsDataNotStarted, setCollegeStatsNotStartedData] = React.useState<any>();
    const [showCollegeStatsModal, setShowCollegeStatsModal] = React.useState<boolean>(false);
    const [showCollegeStatsNotModal, setShowCollegeStatsNotModal] = React.useState<boolean>(false);

    const getCollegeStatsData = async () => {
        try {
            const res: any = await ClientService.getCollegeStatsData();
            if (res.status === 200) {
                const uniqueColleges = res.data?.data?.uniqueColleges || [];
                const startedColleges = res.data?.data?.startedColleges || [];

                setCollegeStatsStartedData(startedColleges);

                const notStartedColleges = uniqueColleges.filter(
                    (college: any) =>
                        !startedColleges.some(
                            (started: any) => started.collegeId === college.collegeId
                        )
                );

                setCollegeStatsNotStartedData(notStartedColleges);
            } else {
                console.error("Failed to fetch college stats:", res);
            }
        } catch (error: any) {
            console.error("Error fetching college stats:", error);
        }
    };


    const startedCsvLink = useRef<any>();
    const notStartedCsvLink = useRef<any>();

    async function getBasicStats() {
        setLoading(true);
        await ClientService.getReverificationStats()
            .then((res: any) => {
                if (res.status === 200) {
                    const statsData = res.data?.data || {};
                    setData(statsData);

                    const verifiedStudents = statsData.successCount || 0;
                    const totalStudents = statsData.assignedStudents || 0;
                    const notVerifiedStudents = totalStudents - verifiedStudents;

                    const newChartData: ChartDataItem[] = [
                        {
                            category: "Verified",
                            value: verifiedStudents,
                            fill: "#28a745"
                        },
                        {
                            category: "Not Verified",
                            value: notVerifiedStudents,
                            fill: "#6c757d"
                        }
                    ];
                    setChartData(newChartData);
                } else {
                    console.error("Failed to fetch stats:", res);
                }
            })
            .catch((error: any) => {
                console.error("Error fetching stats:", error);
            })
            .finally(() => {
                setLoading(false);
            });
    }

    useEffect(() => {
        getBasicStats();
        getCollegeStatsData();
    }, []);


    return (
        <>
            <Row>
                <Col>
                    <ReverificationOverview data={data} chartData={chartData} loading={loading} />
                </Col>
                <Col>
                    <CollegeOverview />
                </Col>
            </Row>
            {/* <Row>
                <Card className="mt-4 shadow" style={{ borderRadius: "16px", border: "1px solid #e9ecef" }}>
                    <Card.Body className="p-4">
                        <h5 className="text-secondary fw-bold mb-3" style={{ fontSize: '18px' }}>
                            College Activity
                        </h5>
                        <Row className="g-3">
                            <Col md={4}>
                                <StatsCard
                                    title="Started Colleges"
                                    value={data?.startedColleges || 0}
                                    icon={faPlay}
                                    iconColor="success"
                                    valueColor="success"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setShowCollegeStatsModal(true)}
                                />
                            </Col>
                            <Col md={4}>
                                <StatsCard
                                    title="Not Started Colleges"
                                    value={(data?.uniqueColleges - data?.startedColleges) || 0}
                                    icon={faPlay}
                                    iconColor="danger"
                                    valueColor="danger"
                                    style={{ cursor: 'pointer' }}
                                    onClick={() => setShowCollegeStatsNotModal(true)}
                                />
                            </Col>
                            <Col md={4}>
                                <StatsCardWithProgress
                                    title="College Participation Rate"
                                    value={`${((data?.startedColleges || 0) / (data?.uniqueColleges || 1) * 100).toFixed(1)}%`}
                                    progress={(data?.startedColleges || 0) / (data?.uniqueColleges || 1) * 100}
                                    icon={faUniversity}
                                    iconColor="info"
                                    valueColor="info"
                                />
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </Row> */}
            <ReverificationsDetails />
            <CollegeStatsModal
                show={showCollegeStatsModal}
                handleClose={() => setShowCollegeStatsModal(false)}
                tableData={collegeStatsDataStarted}
                label='Started'
            />
             <CollegeStatsModal
                show={showCollegeStatsNotModal}
                handleClose={() => setShowCollegeStatsNotModal(false)}
                tableData={collegeStatsDataNotStarted}
                label='Not-Started'
            />
        </>
    )
}